<ion-header class="ion-no-border">

    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="close()">
                <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Edit shipping address</ion-title>
        <ion-buttons *ngIf="online && !loading" slot="end">
            <ion-button (click)="update()">
                <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

</ion-header>

<ion-content>

    <ion-grid *ngIf="online && !loading" class="form">
        <ion-row>
            <ion-col>
                <ion-grid class="fieldset">
                    <ion-row>
                        <ion-col>
                            <ion-input #first_name_input type="text" inputmode="text" maxlength="50" label="First name" labelPlacement="stacked" fill="outline" [(ngModel)]="params['first_name']"></ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input type="text" inputmode="text" maxlength="50" label="Last name" labelPlacement="stacked" fill="outline" [(ngModel)]="params['last_name']"></ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input type="text" inputmode="text" maxlength="100" labelPlacement="stacked" fill="outline" [(ngModel)]="params['organisation_title']">
                                <div slot="label">Organisation title<ion-text class="optional">optional</ion-text></div>
                            </ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input *ngIf="country" class="modal-input" readonly="true" label="Country" labelPlacement="stacked" fill="outline" (click)="presentCountryPickerModal()" value={{country.title}}></ion-input>
                            <ion-input *ngIf="!country" class="modal-input" readonly="true" label="Country" labelPlacement="stacked" fill="outline" (click)="presentCountryPickerModal()"></ion-input>
                        </ion-col>
                    </ion-row>

                    <ng-container *ngIf="country">
                        <ion-row>
                            <ion-col>
                                <ion-input type="text" inputmode="text" maxlength="100" label="Line 1" labelPlacement="stacked" fill="outline" [(ngModel)]="params['line_1']"></ion-input>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col>
                                <ion-input type="text" inputmode="text" maxlength="100" labelPlacement="stacked" fill="outline" [(ngModel)]="params['line_2']">
                                    <div slot="label">Line 2<ion-text class="optional">optional</ion-text></div>
                                </ion-input>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col>
                                <ion-input type="text" inputmode="text" maxlength="50" label="Town / city" labelPlacement="stacked" fill="outline" [(ngModel)]="params['locality']"></ion-input>
                            </ion-col>
                        </ion-row>
                        <ion-row *ngIf="country.title != 'United Kingdom'">
                            <ion-col>
                                <ion-select *ngIf="address_requires_subdivision" cancelText="Close" interface="alert" label="{{address_subdivision_label}}" labelPlacement="stacked" fill="outline" [(ngModel)]="params['subdivision']">
                                    <ion-select-option *ngFor="let subdivision of subdivisions" value="{{subdivision.title}}">{{subdivision.title}}</ion-select-option>
                                </ion-select>
                                <ion-input *ngIf="!address_requires_subdivision" type="text" inputmode="text" maxlength="50" labelPlacement="stacked" fill="outline" [(ngModel)]="params['subdivision']">
                                    <div slot="label">{{address_subdivision_label}}<ion-text class="optional">optional</ion-text></div>
                                </ion-input>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col>
                                <ion-input *ngIf="address_requires_postal_code" type="text" inputmode="text" maxlength="10" label="{{address_postal_code_label}}" labelPlacement="stacked" fill="outline" [(ngModel)]="params['postal_code']"></ion-input>
                                <ion-input *ngIf="!address_requires_postal_code" type="text" inputmode="text" maxlength="10" labelPlacement="stacked" fill="outline" [(ngModel)]="params['postal_code']">
                                    <div slot="label">{{address_postal_code_label}}<ion-text class="optional">optional</ion-text></div>
                                </ion-input>
                            </ion-col>
                        </ion-row>
                    </ng-container>

                    <ion-row>
                        <ion-col>
                            <ion-textarea type="text" inputmode="text" maxlength="100" [autoGrow]="true" rows="5" labelPlacement="stacked" fill="outline" [(ngModel)]="params['courier_instructions']">
                                <div slot="label">Courier instructions<ion-text class="optional">optional</ion-text></div>
                            </ion-textarea>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input type="tel" inputmode="tel" maxlength="20" labelPlacement="stacked" fill="outline" [(ngModel)]="params['mobile_phone_number']">
                                <div slot="label">Mobile phone number<ion-text class="optional">optional</ion-text></div>
                            </ion-input>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>
    </ion-grid>

</ion-content>